import * as apiUrls from "@/constants/api.js";

export default class {
  constructor(axios) {
    this.axios = axios;
  }

  /********************* helper ***************************/
  handleApiCall(apiPromise) {
    return apiPromise.then(response => response.data);
  }

  convertOptionToString(option) {
    return option?.Value || "";
  }

  // 目前僅剩 account 在使用，這是因為 common-select 的緣故
  covertOptionToApiString(option) {
    return option?.code || "";
  }

  // 目前僅剩 account & role 在使用，這是因為 common-select 的緣故
  convertApiOptionToValue(option) {
    return option ? { code: option.Key, label: option.Value } : "";
  }

  // v2
  convertApiOption(option) {
    return option.Key ? option : "";
  }

  addOptionDefault(option) {
    return option || {};
  }
  /********************* helper ***************************/

  getAssessmentStatus() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "AssessmentStatus"
          }
        ]
      })
    );
  }

  querySubjects(conditions) {
    return this.handleApiCall(
      this.axios.post(apiUrls.querySubjects, conditions)
    );
  }

  querySubjectsByJob(conditions) {
    return this.handleApiCall(
      this.axios.post(apiUrls.querySubjectsByJob, conditions)
    );
  }

  getPerformanceList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "Performance"
          }
        ]
      })
    );
  }

  getGraduationList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          { ParameterTypeCategory: "Platform", ParameterTypeCode: "Graduation" }
        ]
      })
    );
  }

  getProfessionList(removeEmptySubjectsOfProfessionCollection = false) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "Profession",
            RemoveEmptySubjectsOfProfessionCollection: removeEmptySubjectsOfProfessionCollection
          }
        ]
      })
    );
  }

  getHierarchyList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          { ParameterTypeCategory: "Platform", ParameterTypeCode: "Class" }
        ]
      })
    );
  }

  getPositionList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          { ParameterTypeCategory: "Platform", ParameterTypeCode: "Position" }
        ]
      })
    );
  }

  getDepartmentList(removeEmptySubjects = false) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryDepartmentsSimplyInfoTree, {
        Conditions: [{ RemoveEmptySubjects: removeEmptySubjects }]
      })
    );
  }

  getSimpleDepartmentList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.querySimpleDepartment, {
        Conditions: []
      })
    );
  }

  getIdentityList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          { ParameterTypeCategory: "Platform", ParameterTypeCode: "Identity" }
        ]
      })
    );
  }

  getHarrisonProfessionList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "HarrisonProfession"
          }
        ]
      })
    );
  }

  getPhoneCountryCode() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "PhoneCountryCode"
          }
        ]
      })
    );
  }

  createAssessments(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createAssessments, {
        Contents: data
      })
    );
  }

  deleteSubject(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteSubject, {
        Contents: data
      })
    );
  }

  shareAssessmentV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.shareAssessmentV2, {
        Contents: data
      })
    );
  }

  reinviteAssessmentV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.reinviteAssessmentV2, {
        Contents: data
      })
    );
  }

  deleteAssessmentV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteAssessmentV2, {
        Contents: data
      })
    );
  }

  querySimpleAccountTree() {
    return this.handleApiCall(
      this.axios.post(apiUrls.querySimpleAccountTree, {
        Conditions: []
      })
    );
  }

  getSubjectDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getSubjectDetail, {
        Conditions: data
      })
    );
  }

  queryJobs({ keyword, searchBy, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryJobs, {
        Conditions: [
          {
            SortBy: "",
            Ordering: "",
            Keyword: keyword ? keyword : null,
            SearchBy: searchBy ? searchBy : null
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  releaseJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.releaseJobs, { Contents: data })
    );
  }

  copyJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.copyJobs, { Contents: data })
    );
  }

  resumeJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.resumeJobs, { Contents: data })
    );
  }

  archiveJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.archiveJobs, { Contents: data })
    );
  }

  getLanguage() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Company",
            ParameterTypeCode: "AvailableLanguage"
          }
        ]
      })
    );
  }

  getContactInfo() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Company",
            ParameterTypeCode: "ContentWindow"
          }
        ]
      })
    );
  }

  queryExamsSimplyInfo() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryExamsSimplyInfo, {
        Conditions: []
      })
    );
  }

  createJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createJobs, {
        Contents: data
      })
    );
  }

  deleteJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteJobs, {
        Contents: data
      })
    );
  }

  getJobPreviewCode(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getJobPreviewCode, {
        Contents: data
      })
    );
  }

  getJobDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getJobDetail, {
        Conditions: data
      })
    );
  }

  updateJobs(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateJobs, {
        Contents: data
      })
    );
  }

  queryJobsSimplyInfoTree() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryJobsSimplyInfoTree, {
        Conditions: []
      })
    );
  }

  queryJobSubjects(conditions) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryJobSubjects, conditions)
    );
  }

  querySubjectsSimplyInfoTree() {
    return this.handleApiCall(
      this.axios.post(apiUrls.querySubjectsSimplyInfoTree, {
        Conditions: []
      })
    );
  }

  createJobSubjects(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createJobSubjects, {
        Contents: data
      })
    );
  }

  createSubjectsV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createSubjectsV2, {
        Contents: data
      })
    );
  }

  deleteJobSubjects(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteJobSubjects, {
        Contents: data
      })
    );
  }

  inviteJobSubjects(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.inviteJobSubjects, {
        Contents: data
      })
    );
  }

  updateSubjectsV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateSubjectsV2, {
        Contents: data
      })
    );
  }

  queryExams({ keyword, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryExams, {
        Conditions: [
          {
            SortBy: "",
            Ordering: "",
            Keyword: keyword === "" ? null : keyword
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  copyExams(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.copyExams, {
        Contents: data
      })
    );
  }

  createExams(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExams, {
        Contents: data
      })
    );
  }

  deleteExams(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteExams, {
        Contents: data
      })
    );
  }

  updateExams(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExams, {
        Contents: data
      })
    );
  }

  queryExamQuestions({ examId, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryExamQuestions, {
        Conditions: [
          {
            ExamId: examId,
            SortBy: "",
            Ordering: "",
            Keyword: null
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  getExamDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getExamDetail, {
        Conditions: data
      })
    );
  }

  copyExamQuestions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.copyExamQuestions, {
        Contents: data
      })
    );
  }

  updateExamQuestionsOrder(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExamQuestionsOrder, {
        Contents: data
      })
    );
  }

  getExamType1PreparePeriodList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType1PreparePeriod"
          }
        ]
      })
    );
  }

  getExamType1AnswerLimitedPeriod() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType1AnswerLimitedPeriod"
          }
        ]
      })
    );
  }

  getExamType1RerecordTimes() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType1RerecordTimes"
          }
        ]
      })
    );
  }

  getSTTLanguage() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "STTLanguage"
          }
        ]
      })
    );
  }

  createExamType1Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExamType1Questions, {
        Contents: data
      })
    );
  }

  getExamType2PreparePeriod() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType2PreparePeriod"
          }
        ]
      })
    );
  }

  getExamType2AnswerLimitedPeriod() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType2AnswerLimitedPeriod"
          }
        ]
      })
    );
  }

  createExamType2Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExamType2Questions, {
        Contents: data
      })
    );
  }

  getExamType3LimitedPeriod() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType3LimitedPeriod"
          }
        ]
      })
    );
  }

  createExamType3Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExamType3Questions, {
        Contents: data
      })
    );
  }

  getExamType4LimitedPeriod() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "ExamType4LimitedPeriod"
          }
        ]
      })
    );
  }

  createExamType4Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExamType4Questions, {
        Contents: data
      })
    );
  }

  getQuestionBankSuit(language) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.queryParameters,
        {
          Conditions: [
            {
              ParameterTypeCategory: "Company",
              ParameterTypeCode: "QuestionBankSuit"
            }
          ]
        },
        {
          headers: {
            "accept-language": language
          }
        }
      )
    );
  }

  getQuestionBankCategory(language) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.queryParameters,
        {
          Conditions: [
            {
              ParameterTypeCategory: "Company",
              ParameterTypeCode: "QuestionBankCategory"
            }
          ]
        },
        {
          headers: {
            "accept-language": language
          }
        }
      )
    );
  }

  getQuestionBankQuestion(language) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.queryParameters,
        {
          Conditions: [
            {
              ParameterTypeCategory: "Company",
              ParameterTypeCode: "QuestionBankQuestion"
            }
          ]
        },
        {
          headers: {
            "accept-language": language
          }
        }
      )
    );
  }

  queryQuestionFromQuestionBank(data) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.queryQuestionFromQuestionBank,
        {
          Conditions: [data]
        },
        {
          headers: {
            "accept-language": data.LangCode
          }
        }
      )
    );
  }

  createExamType1QuestionsFromQuestionBank(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createExamType1QuestionsFromQuestionBank, {
        Contents: data
      })
    );
  }

  deleteExamQuestions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteExamQuestions, {
        Contents: data
      })
    );
  }

  getExamType1QuestionDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getExamType1QuestionDetail, {
        Conditions: data
      })
    );
  }

  updateExamType1Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExamType1Questions, {
        Contents: data
      })
    );
  }

  getExamType2QuestionDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getExamType2QuestionDetail, {
        Conditions: data
      })
    );
  }

  updateExamType2Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExamType2Questions, {
        Contents: data
      })
    );
  }

  getExamType3QuestionDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getExamType3QuestionDetail, {
        Conditions: data
      })
    );
  }

  updateExamType3Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExamType3Questions, {
        Contents: data
      })
    );
  }

  getExamType4QuestionDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getExamType4QuestionDetail, {
        Conditions: data
      })
    );
  }

  updateExamType4Questions(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateExamType4Questions, {
        Contents: data
      })
    );
  }

  queryDepartments({ keyword, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryDepartments, {
        Conditions: [
          {
            Keyword: keyword === "" ? null : keyword
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  createDepartments(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createDepartments, {
        Contents: data
      })
    );
  }

  updateDepartments(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateDepartments, {
        Contents: data
      })
    );
  }

  deleteDepartments(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteDepartments, {
        Contents: data
      })
    );
  }

  queryAccounts({ keyword, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryAccounts, {
        Conditions: [
          {
            Keyword: keyword === "" ? null : keyword
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  getTimeZoneList() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          { ParameterTypeCategory: "Platform", ParameterTypeCode: "TimeZone" }
        ]
      })
    );
  }

  queryRoles(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryRoles, {
        Conditions: data
      })
    );
  }

  createAccounts(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createAccounts, {
        Contents: data
      })
    );
  }

  deleteAccounts(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteAccounts, {
        Contents: data
      })
    );
  }

  updateAccounts(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateAccounts, {
        Contents: data
      })
    );
  }

  getPermissionsMetaData() {
    return this.handleApiCall(
      this.axios.post(apiUrls.getPermissionsMetaData, {
        Conditions: []
      })
    );
  }

  createRoles(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createRoles, {
        Contents: data
      })
    );
  }

  deleteRoles(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteRoles, {
        Contents: data
      })
    );
  }

  getRoleDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getRoleDetail, {
        Conditions: data
      })
    );
  }

  updateRoles(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateRoles, {
        Contents: data
      })
    );
  }

  getParameterTypes() {
    return this.handleApiCall(
      this.axios.post(apiUrls.getParameterTypes, {
        Conditions: []
      })
    );
  }

  queryParameterTypeParameters({ category, typeCode, page, rowsPerPage }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameterTypeParameters, {
        Conditions: [
          {
            ParameterTypeCategory: category,
            ParameterTypeCode: typeCode
          }
        ],
        Page: page,
        RowsPerPage: rowsPerPage
      })
    );
  }

  getAvailableEditMode() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Platform",
            ParameterTypeCode: "AvailableEditMode"
          }
        ]
      })
    );
  }

  createParameterTypeParameters(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.createParameterTypeParameters, {
        Contents: data
      })
    );
  }

  deleteParameterTypeParameters(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.deleteParameterTypeParameters, {
        Contents: data
      })
    );
  }

  getParameterTypeParameterDetail(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getParameterTypeParameterDetail, {
        Conditions: data
      })
    );
  }

  updateParameterTypeParameters(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateParameterTypeParameters, {
        Contents: data
      })
    );
  }

  getAssessmentReport(data, options = {}) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.getAssessmentReport,
        {
          Conditions: data
        },
        options
      )
    );
  }

  getAssessmentReportV2(data, options = {}) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.getAssessmentReportV2,
        {
          Conditions: data
        },
        options
      )
    );
  }

  getAssessmentReportByToken(data, options) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.getAssessmentReportByToken,
        {
          Contents: data
        },
        options
      )
    );
  }

  getAssessmentReportByTokenV2(data, options) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.getAssessmentReportByTokenV2,
        {
          Contents: data
        },
        options
      )
    );
  }

  getVideoAssessmentReport(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getVideoAssessmentReport, {
        Conditions: data
      })
    );
  }

  getVideoAssessmentReportByToken(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getVideoAssessmentReportByToken, {
        Contents: data
      })
    );
  }

  updateVideoAssessmentScore(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateVideoAssessmentScore, {
        Contents: data
      })
    );
  }

  login(params) {
    return this.handleApiCall(
      this.axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: apiUrls.postLogin,
        data: params,
        withCredentials: true
      })
    );
  }

  requestForgetPassword({ email }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.requestForgetPassword, {
        Email: email
      })
    );
  }

  updateUserPassword({ token, password }) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateUserPassword, {
        Token: token,
        Password: password
      })
    );
  }

  refreshToken() {
    return this.handleApiCall(this.axios.post(apiUrls.refreshToken, {}));
  }

  getLogoSetting() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Company",
            ParameterTypeCode: "CompanyData"
          }
        ]
      })
    );
  }

  updateMyAccount(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateMyAccount, {
        Contents: data
      })
    );
  }

  logout() {
    return this.handleApiCall(this.axios.post(apiUrls.logout));
  }

  getSideBarSetting() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryParameters, {
        Conditions: [
          {
            ParameterTypeCategory: "Company",
            ParameterTypeCode: "Configuration"
          }
        ]
      })
    );
  }

  getAccountDetail() {
    return this.handleApiCall(
      this.axios.post(apiUrls.getAccountDetail, {
        Conditions: []
      })
    );
  }

  uploadFile(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.uploadFile, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  notifyAssessmentV2(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.notifyAssessmentV2, {
        Contents: data
      })
    );
  }

  getJobAIValuesWeight(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getJobAIValuesWeight, {
        Conditions: data
      })
    );
  }

  updateJobAIValuesWeight(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateJobAIValuesWeight, {
        Contents: data
      })
    );
  }

  getJob9BoxWeight(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getJob9BoxWeight, {
        Conditions: data
      })
    );
  }

  updateJob9BoxWeight(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateJob9BoxWeight, {
        Contents: data
      })
    );
  }

  getCatAssessmentImportTemplate(parameter) {
    return this.handleApiCall(
      this.axios.get(apiUrls.getCatAssessmentImportTemplate, {
        params: parameter,
        responseType: "blob"
      })
    );
  }

  checkCatAssessmentImportTemplate(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkCatAssessmentImportTemplate, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  getHarrisonAssessmentImportTemplate(parameter) {
    return this.handleApiCall(
      this.axios.get(apiUrls.getHarrisonAssessmentImportTemplate, {
        params: parameter,
        responseType: "blob"
      })
    );
  }

  checkHarrisonAssessmentImportTemplate(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkHarrisonAssessmentImportTemplate, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  getDdiAssessmentImportTemplate(parameter) {
    return this.handleApiCall(
      this.axios.get(apiUrls.getDdiAssessmentImportTemplate, {
        params: parameter,
        responseType: "blob"
      })
    );
  }

  checkDdiAssessmentImportTemplate(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkDdiAssessmentImportTemplate, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  getJobSubjectsImportTemplate(parameter) {
    return this.handleApiCall(
      this.axios.get(apiUrls.getJobSubjectsImportTemplate, {
        params: parameter,
        responseType: "blob"
      })
    );
  }

  checkJobSubjectsImportTemplate(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkJobSubjectsImportTemplate, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  getAccountImportTemplate(parameter) {
    return this.handleApiCall(
      this.axios.get(apiUrls.getAccountImportTemplate, {
        params: parameter,
        responseType: "blob"
      })
    );
  }

  checkAccountImportTemplate(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkAccountImportTemplate, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    );
  }

  queryJobSubjectsFor9Box(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryJobSubjectsFor9Box, {
        Conditions: data
      })
    );
  }

  exportAIRawTemplate(data) {
    return this.handleApiCall(
      this.axios.post(
        apiUrls.exportAIRawTemplate,
        {
          Conditions: data
        },
        {
          responseType: "blob"
        }
      )
    );
  }

  updateJobSubjectsStatus(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.updateJobSubjectsStatus, {
        Contents: data
      })
    );
  }

  exportCatRawTemplate() {
    return this.handleApiCall(
      this.axios.get(apiUrls.exportCatRawTemplate, {
        responseType: "blob"
      })
    );
  }

  getJobSearchFields() {
    return this.handleApiCall(this.axios.get(apiUrls.getJobSearchFields));
  }
  resetMFA(data) {
    return this.handleApiCall(
      this.axios({
        method: "post",
        withCredentials: true,
        url: apiUrls.resetMFA,
        data
      })
    );
  }

  queryQuotas() {
    return this.handleApiCall(
      this.axios.post(apiUrls.queryQuotas, {
        Conditions: []
      })
    );
  }

  updateMySecurityStamp() {
    return this.handleApiCall(
      this.axios({
        method: "post",
        url: apiUrls.updateMySecurityStamp
      })
    );
  }
  getQuotaDetail(serviceKey) {
    return this.handleApiCall(
      this.axios.post(apiUrls.getQuotaDetails, {
        Conditions: [
          {
            ServiceKey: serviceKey
          }
        ]
      })
    );
  }

  updateSecurityStamp(data) {
    return this.handleApiCall(
      this.axios({
        method: "post",
        url: apiUrls.updateSecurityStamp,
        data
      })
    );
  }
  getQuotaHistory(data) {
    return this.handleApiCall(this.axios.post(apiUrls.getQuotaHistory, data));
  }

  checkService(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkService, {
        Conditions: data
      })
    );
  }

  checkResidual(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkResidual, {
        Conditions: data
      })
    );
  }

  checkResidualWithPhone(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkResidualWithPhone, {
        Conditions: data
      })
    );
  }

  checkResidualWithSubjectId(data) {
    return this.handleApiCall(
      this.axios.post(apiUrls.checkResidualWithSubjectId, {
        Conditions: data
      })
    );
  }
}
